import { render } from "./credits-overview-dialog.vue?vue&type=template&id=432abeac"
import script from "./credits-overview-dialog.vue?vue&type=script&lang=js"
export * from "./credits-overview-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__